<template>
  <div id="navigation">
    <div
      class="navigation_box black"
      :class="scrollShow ? 'black' : 'navigation_box'"
    >
      <div class="nav_box">
        <div v-for="(item, index) in navList" :key="index" class="nav">
          <div
            :class="index == indexRed ? '' : 'nav_item'"
            @click="cNav(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div
        class="btn_box"
        @click="wapSingel('https://www.qn000.com/#/')"
      ></div>
      <!-- <div
        class="nav-center_release"
        @click="wapSingel('https://www.qn2024.com')"
      ></div> -->
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils/index";
import { selectScroll } from "@/utils/scroll";
export default {
  data() {
    return {
      indexRed: 0,
      scrollShow: false,
      navList: [
        {
          title: "首页",
          show: true,
          href: "#bannerView",
        },
        {
          title: "合作流程",
          show: true,
          href: "#hzFlow",
        },
        {
          title: "引擎介绍",
          show: false,
          href: "#yqshow",
        },
        {
          title: "商务合作",
          show: false,
          href: "#business",
        },
        {
          title: "授权展示",
          show: false,
          href: "#sqshow",
        },
        {
          title: "游戏专区",
          show: false,
          href: "#gameSingle",
        },
        {
          title: "下载中心",
          show: false,
          href: "#download",
        },
      ],
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    wapSingel(url, target = "_blank") {
      if (!url) {
        return;
      }
      const dowa = document.createElement("a");
      dowa.href = url;
      dowa.target = target;
      document.body.appendChild(dowa);
      dowa.click();
      document.body.removeChild(dowa);
    },
    handleScroll() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      if (document.documentElement.scrollTop == 0) {
        this.scrollShow = false;
      } else {
        this.scrollShow = true;
      }
      if (document.documentElement.scrollTop < 300) {
        this.scrollShowfixed = false;
      } else {
        this.scrollShowfixed = true;
      }
    },
    cNav(index) {
      let idName = document.querySelector(`#nav_${index+1}`)
      this.indexRed = index;
      selectScroll(idName)
    },
  },
};
</script>

<style lang="scss" scoped>
#navigation {
  width: 100%;
  // height:1.125rem /* 90/80 */ /* 90/192 */;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999;

  .navigation_box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.375rem /* 30/80 */;
    padding-bottom: 0.3rem /* 24/80 */;
  }
  .black {
    z-index: 999;
    // background: #000;
    background: rgba($color: #000000, $alpha: .32);
    backdrop-filter: blur(.0375rem);
    // box-shadow: 0 0.025rem /* 2/80 */ 0.1rem /* 8/80 */ 0 #10070f;
  }

}

.nav_box {
  display: flex;
  align-items: center;
  justify-content: center;

  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.2rem;
    color: #ffffff;
    padding-right: 0.625rem;
    .nav_item:hover {
      color: red;
      cursor: pointer;
    }
  }
}
.activate {
  color: red !important;
}
.btn_box {
  width: 3.4875rem /* 279/80 */;
  height: 0.7875rem /* 63/80 */;
  background: url("../../assets/images/enterinto.png") no-repeat;
  background-size: contain;
  margin-left: 0.4rem /* 140/192 */;
  cursor: pointer;
}
.nav-center_release {
  margin-left: 0.25rem /* 20/80 */;
  width: 3.7rem /* 296/80 */;
  height: 0.825rem /* 66/80 */;
  background: url("../../assets/images/release.png") no-repeat center;
  background-size: cover;
  cursor: pointer;
}
.nav_click {
  color: red;
  cursor: pointer;
}

// #navigation:hover {
//
// }

// banner
</style>
